/**
 *
 * @component 用户中心/数据看板/----施工延期
 *
 **/

import dayjs from 'dayjs';
import { useHistory } from 'react-router-dom';
import { Empty } from 'antd';
import BaseCard from '@/components/UserCenter/BaseCard';
import './PostponeCard.scss';

function PostponeCard(props) {
    const { defaultValue = [] } = props;

    const { length } = defaultValue;

    const [page, setPage] = useState(0);

    const onPageChange = (advance = true) => {
        let next = page;
        if (advance) {
            next = length - (page + 1) * 4 > 0 ? page + 1 : page;
        } else {
            next = page === 0 ? 0 : page - 1;
        }
        setPage(next);
    };

    // 跳转已延期的项目列表
    const targetList = () => {
        HISTORY.push('/user-center/project-space?status=4');
    };

    const more = (
        <>
            <i
                className={`outlined icon-arrow-right1 page-icon${
                    page === 0 ? ' type--disabeld' : ''
                }`}
                onClick={() => onPageChange(false)}></i>
            <i
                className={`outlined icon-arrow-left1  page-icon ${
                    length - (page + 1) * 4 > 0 ? '' : ' type--disabeld'
                }`}
                onClick={onPageChange}></i>
            <span onClick={targetList} className="type--normal native-link">
                {intl.get('base.viewMore')}
            </span>
        </>
    );
    const HISTORY = useHistory();
    const targetProject = projectId => {
        const path = `/user-center/project-space/scheme-detail?id=${projectId}&tab=plans`;
        HISTORY.push(path);
    };
    return (
        <BaseCard
            className="postpone-card"
            title={`施工延期（${length}）`}
            headerExtra={more}>
            {!defaultValue.length && (
                <Empty
                    image={
                        require('&/assets/img/userCenter/emptyydata-object.png')
                            .default
                    }
                    imageStyle={{
                        height: 160,
                    }}
                    description={
                        <div className="hint-message">暂无数据</div>
                    }></Empty>
            )}
            {defaultValue
                ?.slice((page + 1) * 4 - 4, (2 + page) * 4 - 4)
                .map(item => (
                    <section
                        className="postpone-item"
                        key={item.projectId}
                        onClick={() => targetProject(item.projectId)}>
                        <header
                            title={item.name}
                            className="project-name text-no-wrap">
                            {item.name}
                        </header>
                        <p className="postpone-map">
                            <span className="postpone-label">施工项：</span>
                            {item.stageName}
                        </p>
                        <p
                            className="postpone-map text-no-wrap"
                            title={item.manager}>
                            <span className="postpone-label">项目经理：</span>
                            {item.manager}
                        </p>
                        <p className="postpone-map">
                            <span className="postpone-label">工期：</span>
                            {dayjs(item.timeAt * 1e3 || undefined).format(
                                'YYYY.MM.DD'
                            )}
                            -
                            {dayjs(item.timeEnd * 1e3 || undefined).format(
                                'YYYY.MM.DD'
                            )}
                        </p>
                    </section>
                ))}
        </BaseCard>
    );
}

export default PostponeCard;
